import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { NavBar } from "./components/NavBar";
import { Home } from "./pages/Home";
import { Footer } from "./components/Footer";
import { TireSearchResults } from "./pages/TireSearchResults";
import { Cart } from "./pages/Cart";
import { Checkout } from "./pages/Checkout";
import { BookingConfirmation } from "./pages/BookingConfirmation";
import AboutUs from "./pages/navbarPages/AboutUs";
import Features from "./pages/navbarPages/Features";
import ContactUs from "./pages/navbarPages/ContactUs";
import Blogs from "./pages/blogs/Blogs";
import RightTires from "./pages/blogs/RightTires";
import ReplaceTires from "./pages/blogs/ReplaceTires";
import WheelAlignment from "./pages/blogs/WheelAlignment";
import EvTires from "./pages/blogs/EvTires";
import WheelSizeEv from "./pages/blogs/WheelSizeEv";
import WirelessMonitoringSystem from "./pages/blogs/WirelessMonitoringSystem";
import RoadTripPreparation from "./pages/blogs/RoadTripPreparation";
import HassleFreeInstallations from "./pages/blogs/HassleFreeInstallations";
import SensorBasedAlignment from "./pages/blogs/SensorBasedAlignment";
import FAQ from "./pages/navbarPages/Faq";
import WheelTorque from "./pages/blogs/WheelTorque";
import ScrollToTop from "./components/ScrollToTop";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import { AuthProvider } from "./context/AuthProvider";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { Dashboard } from "./pages/admin/dashboard/Dashboard";
import RequriedAuth from "./components/RequriedAuth";
import { AdminSettingsLayout } from "./pages/adminSettings/AdminSettingsLayout";
import { Users } from "./pages/adminSettings/users/Users";
import { AddUser } from "./pages/adminSettings/users/AddUser";
import { UserRoles } from "./pages/adminSettings/userRoles/UserRoles";
import { DeleteProvider } from "./context/DeleteProvider";
import AccessControl from "./pages/adminSettings/accessControl/AccessControl";
import { EditUser } from "./pages/adminSettings/users/EditUser";
import { AccessControlProvider } from "./context/AccessControlProvider";
import Unauthorized from "./components/Unauthorized";
import { BookService } from "./pages/BookService";
import { ConfirmProvider } from "./context/ConfirmProvider";
import { ConfirmPopup } from "./components/ConfirmPopup";
import { Transactions } from "./pages/adminSettings/paymentGateways/transactions/Transactions";
import { CreditCards } from "./pages/adminSettings/paymentGateways/creditCards/CreditCards";
import { PaymentGatewaySettings } from "./pages/adminSettings/paymentGateways/settings/PaymentGatewaySettings";
import { Gateways } from "./pages/adminSettings/paymentGateways/gateways/Gateways";
import { PaymentGatewaysForm } from "./pages/adminSettings/paymentGateways/gateways/PaymentGatewaysForm";
import { EditPaymentGatewaysForm } from "./pages/adminSettings/paymentGateways/gateways/EditPaymentGatewaysForm";
import { AddService } from "./pages/admin/serviceManagement/AddService";
import { ServiceTypes } from "./pages/adminSettings/serviceType/ServiceTypes";
import { AddServiceType } from "./pages/adminSettings/serviceType/AddServiceType";
import { EditServiceType } from "./pages/adminSettings/serviceType/EditServiceType";
import { VehicleMake } from "./pages/adminSettings/vehicleMake/VehicleMake";
import { AddVehicleMake } from "./pages/adminSettings/vehicleMake/AddVehicleMake";
import { EditVehicleMake } from "./pages/adminSettings/vehicleMake/EditVehicleMake";
import { VehicleModel } from "./pages/adminSettings/VehicleModel/VehicleModel";
import { AddVehicleModel } from "./pages/adminSettings/VehicleModel/AddVehicleModel";
import { EditVehicleModel } from "./pages/adminSettings/VehicleModel/EditVehicleModel";
import { TireFitment } from "./pages/adminSettings/Inventory/tireFitment/TireFitment";
import { AddTireFitment } from "./pages/adminSettings/Inventory/tireFitment/AddTireFitment";
import { EditTireFitment } from "./pages/adminSettings/Inventory/tireFitment/EditTireFitment";
import { WheelFitment } from "./pages/adminSettings/Inventory/wheelFitment/WheelFitment";
import { AddWheelFitment } from "./pages/adminSettings/Inventory/wheelFitment/AddWheelFitment";
import { EditWheelFitment } from "./pages/adminSettings/Inventory/wheelFitment/EditWheelFitment";
import { EditService } from "./pages/admin/serviceManagement/EditService";
import { BlockDays } from "./pages/admin/blockDays/BlockDays";
import { Locations } from "./pages/location/Locations";
import { AddLocation } from "./pages/location/AddLocation";
import { EditLocation } from "./pages/location/EditLocation";
import { WorkOrders } from "./pages/admin/workOrder/WorkOrders";
import { UpdateWorkOrder } from "./pages/admin/workOrder/UpdateWorkOrder";
import { CustomerEnquiries } from "./pages/admin/customerEnquiries/CustomerEnquiries";
import { Terminals } from "./pages/adminSettings/paymentGateways/Terminals/Terminals";
import { AddTerminal } from "./pages/adminSettings/paymentGateways/Terminals/AddTerminal";
import { EditTerminal } from "./pages/adminSettings/paymentGateways/Terminals/EditTerminal";
import { EmailLogs } from "./pages/admin/emailLogs/EmailLogs";
import ViewEmailBody from "./pages/admin/emailLogs/ViewEmailBody";
import PageNotFound from "./pages/notFound/PageNotFound";
import { Appointments } from "./pages/admin/appointment/Appointments";
import { TireInventory } from "./pages/adminSettings/Inventory/tireInventory/TireInventory";
import { TireBrands } from "./pages/adminSettings/Inventory/tireBrand/TireBrands";
import { AddTireBrand } from "./pages/adminSettings/Inventory/tireBrand/AddTireBrand";
import { EditTireBrand } from "./pages/adminSettings/Inventory/tireBrand/EditTireBrand";
import { TireModels } from "./pages/adminSettings/Inventory/tireModel/TireModels";
import { AddTireModel } from "./pages/adminSettings/Inventory/tireModel/AddTireModel";
import { EditTireModel } from "./pages/adminSettings/Inventory/tireModel/EditTireModel";
import { TireProducts } from "./pages/adminSettings/Inventory/tireProduct/TireProducts";
import { AddTireProduct } from "./pages/adminSettings/Inventory/tireProduct/AddTireProduct";
import { EditTireProduct } from "./pages/adminSettings/Inventory/tireProduct/EditTireProduct";
import { Vendors } from "./pages/admin/vendorManagement/Vendors";
import { ReOrderTireItems } from "./pages/admin/vendorManagement/ReOrderTireItems";
import { PurchaseOrders } from "./pages/admin/vendorManagement/PurchaseOrders";
import { CreatePurchaseOrder } from "./pages/admin/vendorManagement/CreatePurchaseOrder";
import { AddTireInventory } from "./pages/adminSettings/Inventory/tireInventory/AddTireInventory";
import { EditTireInventory } from "./pages/adminSettings/Inventory/tireInventory/EditTireInventory";
import { WheelBrands } from "./pages/adminSettings/Inventory/wheelBrand/WheelBrands";
import { WheelModels } from "./pages/adminSettings/Inventory/wheelModel/WheelModels";
import { WheelProducts } from "./pages/adminSettings/Inventory/wheelProduct/WheelProducts";
import { AddWheelBrand } from "./pages/adminSettings/Inventory/wheelBrand/AddWheelBrand";
import { EditWheelBrand } from "./pages/adminSettings/Inventory/wheelBrand/EditWheelBrand";
import { AddWheelModel } from "./pages/adminSettings/Inventory/wheelModel/AddWheelModel";
import { EditWheelModel } from "./pages/adminSettings/Inventory/wheelModel/EditWheelModel";
import { AddWheelProduct } from "./pages/adminSettings/Inventory/wheelProduct/AddWheelProduct";
import { EditWheelProduct } from "./pages/adminSettings/Inventory/wheelProduct/EditWheelProduct";
import { WheelInventory } from "./pages/adminSettings/Inventory/wheelInventory/WheelInventory";
import { AddWheelInventory } from "./pages/adminSettings/Inventory/wheelInventory/AddWheelInventory";
import { EditWheelInventory } from "./pages/adminSettings/Inventory/wheelInventory/EditWheelInventory";
import { AddVendor } from "./pages/admin/vendorManagement/AddVendor";
import { EditVendor } from "./pages/admin/vendorManagement/EditVendor";
import { ReOrderWheelItems } from "./pages/admin/vendorManagement/ReOrderWheelItems";
import { EditPurchaseOrder } from "./pages/admin/vendorManagement/EditPurchaseOrder";
import DailyEstimate from "./pages/admin/dailyEstimate/DailyEstimate";
import AddDailyEstimate from "./pages/admin/dailyEstimate/AddDailyEstimate";
import EditDailyEstimate from "./pages/admin/dailyEstimate/EditDailyEstimate";
import { AllLocations } from "./pages/navbarPages/AllLocations";
import { AuditLogs } from "./pages/adminSettings/logs/auditLogs/AuditLogs";
import { Financials } from "./pages/adminSettings/report/Financials";
import { VendorStatus } from "./pages/adminSettings/status/vendorStatus/VendorStatus";
import { AddVendorStatus } from "./pages/adminSettings/status/vendorStatus/AddVendorStatus";
import { EditVendorStatus } from "./pages/adminSettings/status/vendorStatus/EditVendorStatus";
import { Charts } from "./pages/adminSettings/report/Charts";
import PurchaseOrderPdf from "./pages/admin/vendorManagement/PurchaseOrderPdf";

const Roles = {
  Admin: "Admin"
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <AccessControlProvider>
          <ConfirmProvider>
            <DeleteProvider>
              <NavBar />
              <Routes>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/" element={<Home />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/features" element={<Features />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/locations" element={<AllLocations />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/right-tires" element={<RightTires />} />
                <Route path="/blogs/replace-tires" element={<ReplaceTires />} />
                <Route path="/blogs/wheel-alignment" element={<WheelAlignment />} />
                <Route path="/blogs/ev-tires" element={<EvTires />} />
                <Route path="/blogs/wheel-size" element={<WheelSizeEv />} />
                <Route path="/blogs/wireless-monitoring-system" element={<WirelessMonitoringSystem />} />
                <Route path="/blogs/road-trip-prepration" element={<RoadTripPreparation />} />
                <Route path="/blogs/hassle-free-installations" element={<HassleFreeInstallations />} />
                <Route path="/blogs/sensor-based-alignment" element={<SensorBasedAlignment />} />
                <Route path="/blogs/wheel-torque" element={<WheelTorque />} />
                <Route path="/search-result" element={<TireSearchResults />} />
                <Route path="/book-service" element={<BookService />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/booking-confirm" element={<BookingConfirmation />} />
                <Route path="/unauthorized" element={<Unauthorized />} />

                <Route element={<RequriedAuth allowedRoles={[Roles.Admin]} />}>
                  <Route path="/admin" element={<AdminLayout />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="appointments" element={<Appointments />} />

                    <Route path="dailyEstimate">
                      <Route index element={<DailyEstimate />} />
                      <Route path="adddailyEstimate" element={<AddDailyEstimate />} />
                      <Route path="editdailyEstimate" element={<EditDailyEstimate />} />
                    </Route>

                    <Route path="services/addservice" element={<AddService />} />
                    <Route path="services/editservice" element={<EditService />} />
                    <Route path="workorders" element={<WorkOrders />} />
                    <Route path="workorders/update-workorder" element={<UpdateWorkOrder />} />
                    <Route path="vendors" element={<Vendors />} />
                    <Route path="vendors/add-vendors" element={<AddVendor />} />
                    <Route path="vendors/edit-vendors" element={<EditVendor />} />
                    <Route path="reorder-tire-items" element={<ReOrderTireItems />} />
                    <Route path="reorder-wheel-items" element={<ReOrderWheelItems />} />
                    <Route path="purchase-orders" element={<PurchaseOrders />} />
                    <Route path="purchase-orders/create-purchase-order" element={<CreatePurchaseOrder />} />
                    <Route path="purchase-orders/edit-purchase-order" element={<EditPurchaseOrder />} />
                    <Route path="customerenquiries" element={<CustomerEnquiries />} />
                    <Route path="emaillogs" element={<EmailLogs />} />
                    <Route path="PurchaseOrder/:id" element={<PurchaseOrderPdf />} />
                  </Route>

                  <Route path="/admin/settings" element={<AdminSettingsLayout />}>
                    <Route path="users" element={<Users />} />
                    <Route path="users/add-user" element={<AddUser />} />
                    <Route path="users/edit-user" element={<EditUser />} />
                    <Route path="user-roles" element={<UserRoles />} />
                    <Route path="audit-logs" element={<AuditLogs />} />
                    <Route path="vendor-status" element={<VendorStatus />} />
                    <Route path="vendor-status/add-vendor-status" element={<AddVendorStatus />} />
                    <Route path="vendor-status/edit-vendor-status" element={<EditVendorStatus />} />
                    <Route path="access-control" element={<AccessControl />} />
                    <Route path="tire-inventory" element={<TireInventory />} />
                    <Route path="tire-inventory/add-tire-inventory" element={<AddTireInventory />} />
                    <Route path="tire-inventory/edit-tire-inventory" element={<EditTireInventory />} />
                    <Route path="tire-brands" element={<TireBrands />} />
                    <Route path="tire-brands/add-tire-brand" element={<AddTireBrand />} />
                    <Route path="tire-brands/edit-tire-brand" element={<EditTireBrand />} />
                    <Route path="tire-models" element={<TireModels />} />
                    <Route path="tire-models/add-tire-model" element={<AddTireModel />} />
                    <Route path="tire-models/edit-tire-model" element={<EditTireModel />} />
                    <Route path="tire-products" element={<TireProducts />} />
                    <Route path="tire-products/add-tire-product" element={<AddTireProduct />} />
                    <Route path="tire-products/edit-tire-product" element={<EditTireProduct />} />
                    <Route path="service-types" element={<ServiceTypes />} />
                    <Route path="service-types/add-service-types" element={<AddServiceType />} />
                    <Route path="service-types/edit-service-types" element={<EditServiceType />} />
                    <Route path="vehicle-make" element={<VehicleMake />} />
                    <Route path="vehicle-make/add-vehicle-make" element={<AddVehicleMake />} />
                    <Route path="vehicle-make/edit-vehicle-make" element={<EditVehicleMake />} />
                    <Route path="vehicle-model" element={<VehicleModel />} />
                    <Route path="vehicle-model/add-vehicle-model" element={<AddVehicleModel />} />
                    <Route path="vehicle-model/edit-vehicle-model" element={<EditVehicleModel />} />
                    <Route path="tire-fitment" element={<TireFitment />} />
                    <Route path="tire-fitment/add-tire-fitment" element={<AddTireFitment />} />
                    <Route path="tire-fitment/edit-tire-fitment" element={<EditTireFitment />} />
                    <Route path="wheel-fitment" element={<WheelFitment />} />
                    <Route path="wheel-fitment/add-wheel-fitment" element={<AddWheelFitment />} />
                    <Route path="wheel-fitment/edit-wheel-fitment" element={<EditWheelFitment />} />
                    <Route path="wheel-brands" element={<WheelBrands />} />
                    <Route path="wheel-brands/add-wheel-brand" element={<AddWheelBrand />} />
                    <Route path="wheel-brands/edit-wheel-brand" element={<EditWheelBrand />} />
                    <Route path="wheel-models" element={<WheelModels />} />
                    <Route path="wheel-models/add-wheel-model" element={<AddWheelModel />} />
                    <Route path="wheel-models/edit-wheel-model" element={<EditWheelModel />} />
                    <Route path="wheel-products" element={<WheelProducts />} />
                    <Route path="wheel-products/add-wheel-product" element={<AddWheelProduct />} />
                    <Route path="wheel-products/edit-wheel-product" element={<EditWheelProduct />} />
                    <Route path="wheel-inventory" element={<WheelInventory />} />
                    <Route path="wheel-inventory/add-wheel-inventory" element={<AddWheelInventory />} />
                    <Route path="wheel-inventory/edit-wheel-inventory" element={<EditWheelInventory />} />
                    <Route path="blockdays" element={<BlockDays />} />
                    <Route path="locations" element={<Locations />} />
                    <Route path="locations/add-location" element={<AddLocation />} />
                    <Route path="locations/edit-location" element={<EditLocation />} />
                    <Route path="financials" element={<Financials />} />
                    <Route path="charts" element={<Charts />} />
                    <Route path="payment-gateway-settings" element={<PaymentGatewaySettings />} />
                    <Route path="payment-gateways" element={<Gateways />} />
                    <Route path="payment-gateways-form" element={<PaymentGatewaysForm />} />
                    <Route path="edit-payment-gateways-form" element={<EditPaymentGatewaysForm />} />
                    <Route path="transactions" element={<Transactions />} />
                    <Route path="credit-cards" element={<CreditCards />} />
                    <Route path="terminals" element={<Terminals />} />
                    <Route path="terminals/add-terminal" element={<AddTerminal />} />
                    <Route path="terminals/edit-terminal" element={<EditTerminal />} />
                  </Route>
                </Route>

                <Route path="/admin/emaillogs/view/:id" element={<ViewEmailBody />} />
              </Routes>
              <ConfirmPopup />
              <Footer />
            </DeleteProvider>
          </ConfirmProvider>
        </AccessControlProvider>
      </AuthProvider>
    </Router >
  );
}

export default App;
